import styled from 'styled-components'

export const TextEmphasis = styled.span`
  font-size: ${({ fontSize }) => fontSize || '2.35rem'};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary};
  letter-spacing: -0.5px;
`
